import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const Depth = ({ depth }: SpecProps<"depth">) => {
  const { i18n } = useLingui();

  if (depth == null) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.depth",
    message: "Depth",
    comment: "Field for 'depth' in ad specification",
  });

  const value = i18n.t({
    id: "itemPageLayout.keyInfo.depth.value",
    message: "{depth} cm",
    comment: "Field for 'depth' in ad specification",
    values: { depth: depth },
  });
  return <FieldValuePair field={field} value={value} />;
};
